module.exports = "pegasus/assets/theme3/small/2.jpg";